export default __webpack_public_path__ + "4c33e6c4b7957b835a0daa9681eeb7b4.png";